// import { AutoAwesomeOutlined } from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { defaultLocale } from "../config";
import useChatbot from "../provider/chatbot_provider";
type PromptItem = {
  id: string;
  label: string;
  prompt: string;
};
const LegalPrompts: any = [
  {
    id: "1",
    label: "Formatted Judgement",
    // prompt: "Provide me a structured overview of the judgement",
    prompt: "FormattedJudgement",
  },
  {
    id: "2",
    label: "Summarize",
    // prompt: "Summarise the document highlighting the key points",
    prompt: "Summary",
  },
  {
    id: "3",
    label: "Translate",
    // prompt: "Translate complete document word-to-word in English",
    prompt: "Translate",
  },
];

const QCPrompts = [
  {
    id: "1",
    label: "Customer Info",
    // prompt: "Validate the customer information",
    prompt: "validateCustomerInfo",
  },
  {
    id: "2",
    label: "Validate T&C",
    // prompt: "Validate terms and conditions",
    prompt: "validateT&C",
  },
  {
    id: "3",
    label: "Commercial Quote",
    // prompt: "Perfrom end-to-end QC",
    prompt: "commercialQuoteQC",
  },
];

const initialPrompts: Record<"legal" | "qc", PromptItem[]> = {
  legal: LegalPrompts,
  qc: QCPrompts,
};

export default function DocumentAnalysisInitialPrompts({
  gridSpace = 3,
  align,
  vectorName,
  docChatType = "legal",
}: {
  gridSpace: number;
  align?: string;
  vectorName?: string;
  docChatType: keyof typeof initialPrompts;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { addConversation } = useChatbot();

  return (
    <Grid
      container
      spacing={2}
      alignItems={align || "flex-start"}
      sx={{
        maxWidth: "45rem",
        margin: "0 auto",
        transform: isSmallScreen
          ? "translate(-7px,3.2rem)"
          : "translate(-7px,0)",
      }}
    >
      {initialPrompts[docChatType].map((initialPrompt, index) => (
        <Grid item md={gridSpace} key={index}>
          <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 0.5 + index / 8 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1 }}
          >
            <ButtonBase
              sx={{
                borderRadius: "0.625rem",
                textAlign: "left",
                border: "1px solid #d82a1b",
                color: "#d82a1b",
                width: "100%",
                overflow: "hidden",
              }}
              onClick={() =>
                addConversation(
                  initialPrompt.prompt,
                  defaultLocale,
                  vectorName,
                  "prompt"
                )
              }
            >
              <Box
                sx={{
                  p: 1.5,
                  "&:hover": {
                    // backgroundColor: theme.palette.action.hover,
                    backgroundColor: "#f44336",
                    color: "#fff",
                  },
                  width: "100%",
                }}
                bgcolor={"white"}
                display={"flex"}
                alignItems={"start"}
                gap={2}
              >
                {/* <Box sx={{ scale: "0.9" }}>
                  <AutoAwesomeOutlined />
                </Box> */}
                <Typography
                  variant="body2"
                  title={initialPrompt.label}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    fontSize: "0.75rem",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {initialPrompt.label}
                </Typography>
              </Box>
            </ButtonBase>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
}
